export default function commaSeparatedNumber(num, fixed = 2) {
  return (parseFloat(num)).toFixed(fixed);
}
